module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "structure"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("To the love of my life, Monica, for")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" ins")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("piring")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("me,")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("motivating me, and constant")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("ly")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("pushing")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("me to be")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" a better man, more creativ")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("e, and")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("for")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("the idea that")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" started this whole wil")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("journey!")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Thank you for roughing it")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" o")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("ut with")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("me")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("while this whole thing w")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("orked")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }, [_vm._v("out,")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Love")]), _c('span', {
    staticClass: "noBreak CharOverride-6"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("you")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2d7b7b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MakingVeganMeat-3.vue
// module id = 69
// module chunks = 0